import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "download",
  "use": "download-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"download\">\r\n<path d=\"M19.7778 12V19.7778H4.22222V12H2V19.7778C2 21 3 22 4.22222 22H19.7778C21 22 22 21 22 19.7778V12H19.7778ZM13.1111 12.7444L15.9889 9.87778L17.5556 11.4444L12 17L6.44444 11.4444L8.01111 9.87778L10.8889 12.7444V2H13.1111V12.7444Z\" fill=\"#3A3A3A\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol